import { fromQuery, hasAnyFilter, toQuery } from './listFilters.js';

const storage = () => {
  try {
    return window.sessionStorage;
  } catch (e) {
    return null;
  }
};

const read = (key) => {
  try {
    const store = storage();
    const raw = store && store.getItem('filters:' + key);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

const write = (key, query) => {
  try {
    const store = storage();
    if (store) store.setItem('filters:' + key, JSON.stringify(query));
  } catch (e) {
    /* sem storage o filtro so vive na URL. */
  }
};

const sameQuery = (a, b) => JSON.stringify(a) === JSON.stringify(b);

const keysOf = (ownKeys) => (Array.isArray(ownKeys) ? ownKeys : []);

const pickQuery = (query, keys, inside) => {
  const source = query && typeof query === 'object' ? query : {};
  const next = {};
  Object.keys(source).forEach((name) => {
    if ((keys.indexOf(name) !== -1) === inside) next[name] = source[name];
  });
  return next;
};

export const filtersRouteQuery = (filtersQuery, routeQuery, ownKeys) =>
  Object.assign({}, filtersQuery, pickQuery(routeQuery, keysOf(ownKeys), true));

export const filtersPartOf = (routeQuery, ownKeys) => pickQuery(routeQuery, keysOf(ownKeys), false);

/**
 * Estado dos filtros de uma lista, guardado na URL (`?situacao=ativa`): o link
 * pode ser copiado e o "voltar" do navegador devolve a lista filtrada.
 *
 * Os botoes "Voltar" das telas de engajamento e edicao levam para a rota SEM
 * query. Para eles nao zerarem o filtro, a ultima query tambem fica no
 * sessionStorage, e a lista aberta sem filtro na URL a restaura.
 *
 *   mixins: [listFilterState('broadcast-list', { situacao: '', funcionalidades: [] })]
 */
export const listFilterState = (key, defaults) => ({
  data() {
    return { filters: fromQuery(this.$route.query, defaults) };
  },
  computed: {
    filtersActive() {
      return hasAnyFilter(this.filters);
    },
  },
  created() {
    if (hasAnyFilter(this.filters)) {
      write(key, toQuery(this.filters));
      return;
    }
    const saved = read(key);
    if (saved && Object.keys(saved).length) this.filters = fromQuery(saved, defaults);
  },
  watch: {
    // Sem `immediate`: rodaria antes do created() e gravaria a lista vazia por
    // cima do filtro salvo que o created() ainda vai ler.
    filters: {
      deep: true,
      handler(filters) {
        const query = toQuery(filters);
        write(key, query);
        const next = filtersRouteQuery(query, this.$route.query, this.$options.keepQueryKeys);
        if (!sameQuery(next, this.$route.query)) {
          this.$router.replace({ query: next }).catch(() => {});
        }
      },
    },
    // Link para a mesma lista (menu, aba) com outra query: a URL manda.
    '$route.query'(query) {
      if (!sameQuery(toQuery(this.filters), filtersPartOf(query, this.$options.keepQueryKeys))) this.filters = fromQuery(query, defaults);
    },
  },
  methods: {
    clearFilters() {
      this.filters = fromQuery({}, defaults);
    },
  },
});



// WEBPACK FOOTER //
// ./src/vue/pages/components/default/listFilterState.js